<script>
  export let onClick;
  export let disabled;
</script>

<button on:click={onClick} {disabled} class="c-small-button"><slot /></button>

<style>
  .c-small-button {
    display: inline-block;
    padding: 8px 14px;
    font-size: 15px;
    color: var(--royalBlue-500);
    font-weight: bold;
    white-space: nowrap;
    border: none;
    outline: none;
    border-radius: 40px;
    background-color: #ffffff;
  }

  .c-small-button:hover {
    cursor: pointer;
    background-color: var(--neutral-050);
  }
</style>
